import { isValidPhoneNumber } from 'react-phone-number-input';
import * as yup from 'yup';

export const phoneNumberSchema = yup.object().shape({
  mobilePrefix: yup.string().required(),
  mobileNumber: yup.string().required(),
  mobileNumberWithPrefix: yup
    .string()
    .required()
    .test('is-valid-phone', 'Invalid phone number', (value) => isValidPhoneNumber(value || '')),
});
